
import { Component, Vue, Prop } from "vue-property-decorator";
import Pop from "../components/blue-pop.vue";
import InputNumberV3 from "@/views/ai-builder-v3/components/inputNumberV3.vue";
import IntroduceCard from "@/views/ai-builder-component/components/introduce-card.vue";
import { ExamVersionInfo } from "@/lib/model/exambuilder/exam-component/exam";
import HinaSwitch from "@/views/ai-builder-component/baseComponent/hina-switch.vue";

@Component({
  components: {
    HinaSwitch,
    Pop,
    InputNumberV3,
    IntroduceCard
  }
})
export default class deviceDetection extends Vue {
  @Prop() formItemData!: ExamVersionInfo; // 组件数据

  setGlobal() {
    this.$emit("setGlobal");
  }

  // 校验数据
  formItemCheck() {
    return new Promise((resolve, reject) => {
      const valid = true;
      if (valid) {
        resolve("");
      } else {
        resolve("AiAnswer");
      }
    });
  }
}
